import { fetcher } from '@commenda/utils';

import { TUpdateBillingSkuParams } from './types';

export const updateBillingSku = async (skuId: string, params: TUpdateBillingSkuParams) => {
  const response = await fetcher(`commenda-billing/catalog/skus/${skuId}`, {
    method: 'PATCH',
    body: params,
  });

  return response;
};
